module.exports = __webpack_public_path__ + "img/image2.68d9a99c.jpg";